import { render, staticRenderFns } from "./Business.vue?vue&type=template&id=c45cae98&scoped=true"
import script from "./Business.vue?vue&type=script&lang=js"
export * from "./Business.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45cae98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c45cae98')) {
      api.createRecord('c45cae98', component.options)
    } else {
      api.reload('c45cae98', component.options)
    }
    module.hot.accept("./Business.vue?vue&type=template&id=c45cae98&scoped=true", function () {
      api.rerender('c45cae98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/Business.vue"
export default component.exports